export default {
  mariaCampaign: (state) => state.mariaCampaign,
}
